import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import CompanionBrief from "./components/CompanionBrief/CompanionBrief";
import PainPoint from "./components/PainPoint/PainPoint";
import WhatVertikIs from "./components/WhatVertikIs/WhatVertikIs";
import HowItWorks from "./components/HowItWorks/HowItWorks";
import Capabilities from "./components/Capabilities/Capabilities";
import Product from "./components/Product/Product";
import DayWithVertik from "./components/DayWithVertik/DayWithVertik";
import WhatYouGet from "./components/WhatYouGet/WhatYouGet";
import About from "./components/About/About";
import FAQ from "./components/FAQ/FAQ";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import SectionShell from "./components/SectionShell/SectionShell";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService/TermsOfService";
import styles from "./App.module.scss";

function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const section = document.querySelector(`#${location.state.scrollTo}`);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <>
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <div className={styles.bgContainer}></div>
      <main>
        <Hero />
        <SectionShell variant="surface">
          <CompanionBrief />
        </SectionShell>
        <SectionShell variant="clear">
          <PainPoint />
        </SectionShell>
        <SectionShell variant="surface">
          <WhatVertikIs />
        </SectionShell>
        <SectionShell variant="clear">
          <HowItWorks />
        </SectionShell>
        <SectionShell variant="surface">
          <Capabilities />
        </SectionShell>
        <SectionShell variant="clear">
          <Product />
        </SectionShell>
        <SectionShell variant="surface">
          <DayWithVertik />
        </SectionShell>
        <SectionShell variant="clear">
          <WhatYouGet />
        </SectionShell>
        <SectionShell variant="surface">
          <About />
        </SectionShell>
        <SectionShell variant="clear">
          <FAQ />
        </SectionShell>
        <Contact />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div
      className={` ${styles.app} min-h-screen bg-gradient-to-br from-white via-gray-50 to-purple-50`}
    >
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: "#10B981",
              secondary: "#fff",
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: "#EF4444",
              secondary: "#fff",
            },
          },
        }}
      />
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/term-of-service" element={<TermsOfService />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </div>
  );
}

export default App;
